<template>
  <v-card>
    <v-card-title>
      <h3 class="toolbar__title">General Info</h3>
    </v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col cols="12">
          <strong>{{ location.vending_machine.remain_categories }}</strong> out of <strong>{{ location.vending_machine.full_categories }}</strong> products in stock (<strong>{{ (location.vending_machine.remain_categories / location.vending_machine.full_categories * 100).toFixed(0) }}%</strong>)
        </v-col>
        <v-col cols="12">
          <strong>{{( location.vending_machine.empty_ratios.all * 100).toFixed(0) }}</strong>% stock empty
        </v-col>
        <v-col cols="12">
          <strong>{{ (replenishmentCycle >= 60 ? '>60' : replenishmentCycle) }}</strong> days of avg. replenishment cycle
        </v-col>

        <v-col cols="12">
          <strong>{{ location.engagement }}</strong> customer engagements,
          <strong>{{ location.purchase }}</strong> purchases in 30 days
          (conv. <strong>{{location.engagement ? (location.purchase / location.engagement * 100).toFixed(0) : 0}}%</strong>)
        </v-col>
      </v-row>
    </v-card-text>

  </v-card>
</template>

<script>
  export default {
    props: {
      location: Object
    },

    data () {
      return {
        contractType: {
          '42c47e34-9abd-475d-b24d-c4b167cf8c8b': 'Consignment',
          '3077e5c9-a380-484c-9ae2-a9511afeeacd': 'Slotting',
          '0e1adc11-6bef-4884-a2a7-9c2639778c63': 'Gritus',
          'b3bc62d1-6e8e-46eb-b55a-24dad9672c6f': 'Owner'
        }
      }
    },

    computed: {
      replenishmentCycle () {
        let cycle = parseFloat(this.location.replenishment_cycle)
        if (cycle > 60) {
          return '>60'
        }
        return cycle.toFixed(2)
      },

      productCountGritusOnly () {
        let count = 0
        for (let key in this.location.products) {
          let contractType = this.contractType[this.location.products[key].contract_type_id]
          if (contractType === 'Gritus' || contractType == null) {
            count++
          }
        }
        return count
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/Information/GeneralInfo.vue